<template>
    <div>

        <div class="panel panel-clinic">

            <div class="panel-heading collapsed" href="#form_presentation" data-toggle="collapse">

                <div class="arrow-down"></div>

                <h2 class="panel-title">Presentation</h2>

            </div>

            <div id="form_presentation" class="panel-collapse collapse">

                <div class="panel-body" v-if="!fetcher.loading && panelIsOpen">

                    <h3>Presentationstext ({{ booking_presentation_length }}/250)</h3>
                    <textarea class="form-control" v-model="booking_presentation" maxlength="250" style="height: 150px;"></textarea>

                    <div class="row" style="margin-top: 40px;">
                        <div class="col-md-18">
                            <presentation-portrait
                                :clinic_id="clinic_id"
                                :portrait="portrait"
                                @upload="portraitUpload"
                                @change="portraitChange"
                            />
                        </div>
                        <div class="col-md-30">
                            <presentation-location
                                :clinic_id="clinic_id"
                                :locations="locations"
                                @upload="locationUpload"
                                @remove="locationRemove"
                                @reorder="locationReorder"
                            />
                        </div>
                    </div>

                    <button class="btn btn-primary pull-right" style="margin-top:10px;" :disabled="poster.submitted" @click="posterPost">
                        Spara presentation och foton
                    </button>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

import presentationPortrait from './formComponents/presentation-portrait'
import PresentationLocation from './formComponents/presentation-location'

import poster from '../../../shared/mixins/poster'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    components: {
        presentationPortrait,
        PresentationLocation
    },

    mixins: [
        fetcher,
        poster
    ],

    props: {
        clinic: {
            required: true
        }
    },

    data () {
        return {
            clinic_id: this.clinic.id,
            booking_presentation: '',
            portrait: null,
            locations: [],
            fetcher: {
                autoFill: [
                    'booking_presentation',
                    'portrait',
                    'locations'
                ]
            },
            panelIsOpen: false
        }
    },

    created () {
        bus.$on('refresh-data', () => {
            this.fetcherFetch()
        })
    },

    mounted () {
        $('body').on('shown.bs.collapse', '#form_presentation', () => {
            console.log('show the cropper')

            this.panelIsOpen = true
        })
        $('body').on('hidden.bs.collapse', '#form_presentation', () => {
            console.log('hide the cropper')

            this.panelIsOpen = false
        })
    },

    computed: {
        fetcherUrl () {
            return '/clinics/' + this.clinic_id + '/presentation/fetch'
        },
        posterUrl () {
            return '/clinics/' + this.clinic_id + '/presentation/save'
        },
        posterData () {
            return {
                booking_presentation: this.booking_presentation,
                portrait: this.portrait,
                locations: this.locations
            }
        },
        booking_presentation_length () {
            if (!this.booking_presentation) {
                return 0
            }
            return this.booking_presentation.length
        }
    },

    methods: {

        posterSuccess () {
            bus.$emit('refresh-data', 1)
            bus.$emit('notify', 'Massörens uppgifter har uppdaterats.')
        },

        portraitUpload (image) {
            this.portrait = image
        },

        portraitChange (coordinates) {
            this.portrait.crop_width = coordinates.width
            this.portrait.crop_height = coordinates.height
            this.portrait.crop_left = coordinates.left
            this.portrait.crop_top = coordinates.top
        },

        locationUpload (image) {
            this.locations.push(image)
        },

        locationRemove (index) {
            this.locations.splice(index, 1)
        },

        locationReorder (newOrder) {
            this.locations = newOrder
        }

    }

}
</script>
